module.exports = __webpack_public_path__ + "@/assets/img/dashboard-background.d571d6dc.svg";